// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.gray {
  color: #292727;
}

.heading, .day-heading, .current-day-heading {
  font-weight: 200;
  text-transform: uppercase;
  color: #999;
}

.day-heading, .current-day-heading {
  color: #555;
  font-size: 1.2rem;
  padding-bottom: 0.5rem;
}

.current-day-heading {
  font-weight: bold;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
}

.repeat-rule-popup-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: calc(6000 - 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.repeat-rule-popup-wrapper .repeat-rule-popup {
  background: white;
  padding: 1rem 1rem 0;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  color: #696969;
  box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);
}
.repeat-rule-popup-wrapper .repeat-rule-popup__heading {
  margin: 0 0 1rem;
  font-size: 2rem;
  width: 100%;
}
.repeat-rule-popup-wrapper .repeat-rule-popup__body {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  align-content: center;
  margin: 0 0 0rem;
  width: 22rem;
}
.repeat-rule-popup-wrapper .repeat-rule-popup__body > .margin-top {
  margin-top: 0 !important;
}
.repeat-rule-popup-wrapper .repeat-rule-popup__body .repeat-right-values {
  margin-top: 0.5rem;
}
.repeat-rule-popup-wrapper .repeat-rule-popup__buttons {
  display: flex;
  justify-content: space-evenly;
}
.repeat-rule-popup-wrapper .repeat-rule-popup__buttons .btn-default {
  min-width: 8rem;
}
.repeat-rule-popup-wrapper .repeat-rule-popup label,
.repeat-rule-popup-wrapper .repeat-rule-popup .label {
  font-weight: 100;
  -webkit-font-smoothing: subpixel-antialiased;
}
.repeat-rule-popup-wrapper .add-flex-row {
  margin-top: 10px;
}
.repeat-rule-popup-wrapper .half-opacity {
  opacity: 0.5 !important;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Calendar/RepeatRule/RepeatRulePopup.scss","webpack://./src/Styles/Material.scss","webpack://./src/Styles/Base.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;ADuBA;EACE,cArCU;ACiBZ;;AEhBA;EACE,gBCoBkB;EDnBlB,yBAAA;EACA,WHsCa;ACnBf;;AEhBA;EAEE,WHkCgB;EGjChB,iBAAA;EACA,sBAAA;AFkBF;;AEfA;EAEE,iBAAA;AFiBF;;AEdA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,SAAA;AFiBF;;AA3CA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA6CF;AA3CE;EACE,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,iBAAA;EACA,oBAAA;EAEA,cDtBY;EC0BZ,2DAAA;AA0CJ;AAxCI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AA0CN;AAvCI;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AAyCN;AAvCM;EACE,wBAAA;AAyCR;AAtCM;EACE,kBAAA;AAwCR;AApCI;EACE,aAAA;EACA,6BAAA;AAsCN;AApCM;EACE,eAAA;AAsCR;AAlCI;;EAEE,gBAAA;EACA,4CAAA;AAoCN;AAjCE;EACE,gBAAA;AAmCJ;AAjCE;EACE,uBAAA;AAmCJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n@import '~/Styles/Material';\n@import '~/Styles/Base';\n\n.repeat-rule-popup-wrapper {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  // background-color: rgba(0, 0, 0, 0.5);\n  z-index: calc(#{$modalConfirmLayer} - 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .repeat-rule-popup {\n    background: white;\n    padding: 1rem 1rem 0;\n\n    display: flex;\n    flex-flow: column;\n    align-items: stretch;\n\n    color: $darkTextColor;\n\n    -webkit-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    -moz-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n\n    &__heading {\n      margin: 0 0 1rem;\n      font-size: 2rem;\n      width: 100%;\n    }\n\n    &__body {\n      display: flex;\n      flex-flow: column;\n      align-items: stretch;\n      align-content: center;\n      margin: 0 0 0rem;\n      width: 22rem;\n\n      & > .margin-top {\n        margin-top: 0 !important;\n      }\n\n      .repeat-right-values {\n        margin-top: 0.5rem;\n      }\n    }\n\n    &__buttons {\n      display: flex;\n      justify-content: space-evenly;\n\n      .btn-default {\n        min-width: 8rem;\n      }\n    }\n\n    label,\n    .label {\n      font-weight: 100;\n      -webkit-font-smoothing: subpixel-antialiased;\n    }\n  }\n  .add-flex-row {\n    margin-top: 10px;\n  }\n  .half-opacity {\n    opacity: 0.5 !important;\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.heading {\n  font-weight: $headingFontWeight;\n  text-transform: uppercase;\n  color: $headingColor;\n}\n\n.day-heading {\n  @extend .heading;\n  color: $dayHeadingColor;\n  font-size: 1.2rem;\n  padding-bottom: 0.5rem;\n}\n\n.current-day-heading {\n  @extend .day-heading;\n  font-weight: bold;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  border: 0;\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
